module.exports = __webpack_public_path__ + "static/media/louis2.10324d4c.mp3";